/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PublicBookingRegionsPathParams, PublicBookingRegionsResponse } from '../types/PublicBookingRegions'

/**
 * GET /interview-scheduling/booking/:tokenString/regions
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::regions
 */
export async function publicBookingRegions(
	tokenString: PublicBookingRegionsPathParams['tokenString'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicBookingRegionsResponse>> {
	return axiosInstance.get(`/interview-scheduling/booking/${tokenString}/regions`, config)
}
